import { OnRequestPricingOption, SelectedPricing } from '@shared/types';
import { FunctionComponent } from 'react';
import { OffersSelect } from '../../../../OffersSelect';
import { AddonsSection } from '../../../../AddonsSection';

export type PricingSelectorProps = {
    pricingOption: OnRequestPricingOption;
    selected: SelectedPricing;
    hidePricing?: boolean;
    setSelected: (selected: SelectedPricing) => unknown;
    currency: string;
};

export const PricingSelector: FunctionComponent<PricingSelectorProps> = ({
    pricingOption,
    selected,
    hidePricing,
    setSelected,
    currency,
}) => {
    if (selected.type === 'offers' && pricingOption.type === 'price-offers') {
        return (
            <div>
                <h2>Offers</h2>
                <OffersSelect
                    offers={pricingOption.offers}
                    selectedOffers={selected.offers}
                    availableSpaces={10000}
                    hidePricing={hidePricing}
                    setSelectedOffers={(offers) => {
                        setSelected({ type: 'offers', offers, addOns: selected.addOns });
                    }}
                    currency={currency}
                />

                {pricingOption.add_ons.length ? <h2>Add Ons</h2> : null}
                <AddonsSection
                    addons={pricingOption.add_ons}
                    selectedAddOns={selected.addOns}
                    hidePricing={hidePricing}
                    setSelectedAddOns={(addOns) => {
                        setSelected({ type: 'offers', offers: selected.offers, addOns });
                    }}
                    currency={currency}
                />
            </div>
        );
    }

    if (pricingOption.type === 'price-offers' || selected.type !== 'spaces') {
        throw new Error('Invalid selected pricing option');
    }

    return (
        <div>
            <h2>Spaces</h2>
            <OffersSelect
                offers={[
                    {
                        _id: 'spaces-offer',
                        type: 'offer',
                        name: 'Number of people',
                    },
                ]}
                selectedOffers={{
                    'spaces-offer': selected.quantity,
                }}
                availableSpaces={10000}
                hidePricing={hidePricing}
                setSelectedOffers={(offers) => {
                    setSelected({ type: 'spaces', quantity: offers['spaces-offer'] });
                }}
                currency={currency}
            />
        </div>
    );
};
